import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.345 9.239c2.047 1.271 2.047 4.25 0 5.521l-9.26 5.751c-2.166 1.345-4.965-.213-4.965-2.761V6.25c0-2.549 2.8-4.105 4.965-2.761zm-.792 4.248a1.75 1.75 0 0 0 0-2.974l-9.26-5.75C8.126 4.04 6.62 4.877 6.62 6.25v11.5c0 1.372 1.507 2.21 2.672 1.487z"
  }));
}
var IcPlay = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPlay));

export { IcPlay as I };
